import React from "react";
import { ListGroup } from "components/Shared";
import { Task } from "components/Templates";
import _ from "lodash";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export default class Tasks extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tasks: props.tasks
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    const { tasks } = props;
    this.setState({ tasks });
  }

  onUpdate(task) {
    const { onUpdate } = this.props;
    const { tasks } = this.state;
    tasks.splice(_.findIndex(tasks, {id: task.id}), 1, task)
    this.setState({ tasks: tasks }, onUpdate(tasks));
  }

  onDelete(task) {
    const { onUpdate } = this.props;
    const { tasks } = this.state;
    const newTasks = tasks.filter(_task => _task.id !== task.id);
    this.setState({ tasks: newTasks }, onUpdate(newTasks));
  }

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const { onUpdate } = this.props;
    const { tasks } = this.state;
    
    const reorderedTasks = Array.from(tasks);
    const [removed] = reorderedTasks.splice(result.source.index, 1);
    reorderedTasks.splice(result.destination.index, 0, removed);

    // Update index for all tasks
    const tasksWithNewIndex = reorderedTasks.map((task, index) => ({
      ...task,
      index: index
    }));

    this.setState({ tasks: tasksWithNewIndex }, () => onUpdate(tasksWithNewIndex));
  };

  render() {
    const { template, phase, onAdd } = this.props;
    const { tasks } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId={`phase-${phase.id}-tasks`}>
          {(provided, snapshot) => (
            <div 
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                background: snapshot.isDraggingOver ? 'rgba(0, 123, 255, 0.05)' : 'transparent',
              }}
            >
              <ListGroup
                resource="tasks"
                onAdd={onAdd}
                collection={tasks}
                pagination={false}
                renderRow={(task, index) => (
                  <Draggable key={task.id} draggableId={task.id} index={tasks.indexOf(task)}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                          opacity: snapshot.isDragging ? 0.8 : 1,
                        }}
                      >
                        <Task
                          task={task}
                          phase={phase}
                          template={template}
                          onUpdate={task => this.onUpdate(task)}
                          onDelete={task => this.onDelete(task)}
                        />
                      </div>
                    )}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}
